<template>
  <InvoiceParameterDefaultModal
    title="Regra atualizada com sucesso"
    width="610"
    :show="show"
    @close="$emit('confirm')">
    <template slot="body">
      <div
        class="d-flex flex-row gap-h-10">
        <v-icon color="success">far fa-check-circle</v-icon>
        <TextBase>
          Todos os dados foram atualizados e estão disponíveis para consulta.
        </TextBase>
      </div>
    </template>
    <template slot="actions">
      <div
        class="d-flex justify-center gap-h-20 fill-width">
        <v-btn
          class="action-button-modal"
          color="primary"
          @click="$emit('confirm')">
          Ok
        </v-btn>
      </div>
    </template>
  </InvoiceParameterDefaultModal>
</template>
<script>
import InvoiceParameterDefaultModal from './InvoiceParameterDefaultModal.vue';
import InvoiceParameterText from '../components/InvoiceParameterText.vue';
export default {
  name: "RuleUpdatedSuccessfullyModal",
  components: {
    InvoiceParameterDefaultModal,
    TextBase: InvoiceParameterText
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    }
  },
}
</script>
<style lang="scss">
@import "@/shared/styles/invoiceParameters/default.scss";
</style>